import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "mb-[88px] md:mb-[76px]" }
const _hoisted_2 = {
  key: 1,
  class: "max-w-[1113px] mx-auto mt-6 custom-container-forum"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "flex justify-between items-center mb-6" }
const _hoisted_6 = { class: "text-2xl font-medium leading-7" }
const _hoisted_7 = { class: "flex justify-end items-center gap-3" }
const _hoisted_8 = {
  for: "title",
  class: "block mb-3"
}
const _hoisted_9 = { class: "w-full" }
const _hoisted_10 = {
  key: 0,
  class: "h-[4.5rem] mb-8"
}
const _hoisted_11 = {
  for: "chapter",
  class: "block mb-3"
}
const _hoisted_12 = { class: "flex flex-col flex-wrap items-center max-w-full p-0 mb-8" }
const _hoisted_13 = { class: "sm:w-sm md:w-md lg:w-[1008px] xl:w-[1113px]" }
const _hoisted_14 = {
  for: "description",
  class: "block mb-3"
}
const _hoisted_15 = { class: "ql-formats" }
const _hoisted_16 = { class: "ql-bold" }
const _hoisted_17 = { class: "ql-italic" }
const _hoisted_18 = { class: "ql-underline" }
const _hoisted_19 = { class: "ql-formats" }
const _hoisted_20 = {
  class: "ql-list",
  value: "ordered"
}
const _hoisted_21 = {
  class: "ql-list",
  value: "bullet"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("select", { class: "ql-align" }, null, -1)
const _hoisted_23 = { class: "ql-formats" }
const _hoisted_24 = {
  class: "ql-link",
  value: "link"
}
const _hoisted_25 = { class: "ql-code-block" }
const _hoisted_26 = { class: "w-full custom-comment-input" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_BreadcrumbForum = _resolveComponent("BreadcrumbForum")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Errors = _resolveComponent("Errors")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Editor = _resolveComponent("Editor")!
  const _component_AddFileInput = _resolveComponent("AddFileInput")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createVNode(_component_Loader, {
      loader: _ctx.isFormLoading,
      label: _ctx.$t('labels.generic', { pt: 'Carregando...', en: 'Loading...' }),
      loaderType: "progress"
    }, null, 8, ["loader", "label"]),
    (_ctx.isTeacherOrAdmin() && !_ctx.isFormLoading)
      ? (_openBlock(), _createBlock(_component_BreadcrumbForum, { key: 0 }))
      : _createCommentVNode("", true),
    (!_ctx.isFormLoading)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.backToForumView && _ctx.backToForumView(...args))),
            class: "flex items-center h-8 mb-8 btn-simple"
          }, [
            _createVNode(_component_v_icon, {
              name: "md-arrowback",
              width: "24",
              height: "24"
            }),
            (!_ctx.$route.params.topicId)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t("labels.generic", {
              pt: "Voltar para Fórum",
              en: "Back to Forum",
            })), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$t("labels.generic", {
              pt: "Voltar para tópico",
              en: "Back to Topic",
            })), 1))
          ]),
          _createElementVNode("form", {
            onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitTopicForm && _ctx.submitTopicForm(...args)), ["prevent"]))
          }, [
            _createElementVNode("header", _hoisted_5, [
              _createElementVNode("h2", _hoisted_6, _toDisplayString(!_ctx.$route.params.topicId
                ? _ctx.$t("forum.topic.form.title")
                : _ctx.$t("forum.topic.form.editTitle")), 1),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_Button, {
                  type: "reset",
                  onClick: _ctx.backToForumView,
                  class: "btn-outline"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("forum.topic.form.buttons.cancel")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_Button, {
                  disabled: _ctx.isFormLoading,
                  type: "submit",
                  class: "btn-primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("forum.topic.form.buttons.publish")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ]),
            _createElementVNode("fieldset", null, [
              _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("forum.topic.form.labels.title")), 1),
              _createVNode(_component_InputText, {
                type: "text",
                id: "title",
                modelValue: _ctx.formTopic.title,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formTopic.title) = $event)),
                class: _normalizeClass([[{ 'p-invalid': _ctx.v$.formTopic.title.$error }], "!mb-3"]),
                maxlength: 150
              }, null, 8, ["modelValue", "class"]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_Errors, {
                  errors: _ctx.v$.formTopic.title.$errors,
                  actualLength: _ctx.formTopic.title?.length,
                  maxLength: 150,
                  minLength: 6
                }, null, 8, ["errors", "actualLength"])
              ])
            ]),
            (
            _ctx.courseType !== 'INTERACTIVE' && _ctx.selectChapterOptions.length !== 0
          )
              ? (_openBlock(), _createElementBlock("fieldset", _hoisted_10, [
                  _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("forum.topic.form.labels.tag")), 1),
                  _createVNode(_component_Dropdown, {
                    options: _ctx.selectChapterOptions,
                    class: "w-full",
                    modelValue: _ctx.formTopic.tag,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formTopic.tag) = $event)),
                    optionLabel: "name",
                    optionValue: "name",
                    placeholder: "Selecione o capítulo de referência"
                  }, null, 8, ["options", "modelValue"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("fieldset", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("forum.topic.form.labels.description")), 1),
                _createVNode(_component_Editor, {
                  modelValue: _ctx.formTopic.description,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formTopic.description) = $event)),
                  onTextChange: _ctx.getDescriptionLength,
                  class: _normalizeClass(["mb-3 w-[93vw] sm:w-[624px] md:w-[752px] lg:w-[992px] xl:w-[1113px] custom-comment-input", [
                {
                  'border !border-red-600 rounded-md':
                    _ctx.v$.formTopic.description.$error,
                },
              ]]),
                  editorStyle: "height: 160px; max-width: inherit;"
                }, {
                  toolbar: _withCtx(() => [
                    _createElementVNode("span", _hoisted_15, [
                      _withDirectives(_createElementVNode("button", _hoisted_16, null, 512), [
                        [
                          _directive_tooltip,
                          'Bold',
                          void 0,
                          { bottom: true }
                        ]
                      ]),
                      _withDirectives(_createElementVNode("button", _hoisted_17, null, 512), [
                        [
                          _directive_tooltip,
                          'Italic',
                          void 0,
                          { bottom: true }
                        ]
                      ]),
                      _withDirectives(_createElementVNode("button", _hoisted_18, null, 512), [
                        [
                          _directive_tooltip,
                          'Underline',
                          void 0,
                          { bottom: true }
                        ]
                      ])
                    ]),
                    _createElementVNode("span", _hoisted_19, [
                      _withDirectives(_createElementVNode("button", _hoisted_20, null, 512), [
                        [
                          _directive_tooltip,
                          'Ordered',
                          void 0,
                          { bottom: true }
                        ]
                      ]),
                      _withDirectives(_createElementVNode("button", _hoisted_21, null, 512), [
                        [
                          _directive_tooltip,
                          'Bullet',
                          void 0,
                          { bottom: true }
                        ]
                      ]),
                      _hoisted_22
                    ]),
                    _createElementVNode("span", _hoisted_23, [
                      _withDirectives(_createElementVNode("button", _hoisted_24, null, 512), [
                        [
                          _directive_tooltip,
                          'Link',
                          void 0,
                          { bottom: true }
                        ]
                      ]),
                      _withDirectives(_createElementVNode("button", _hoisted_25, null, 512), [
                        [
                          _directive_tooltip,
                          'CodeBlock',
                          void 0,
                          { bottom: true }
                        ]
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "onTextChange", "class"]),
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_component_Errors, {
                    errors: _ctx.v$.formTopic.description.$errors,
                    actualLength: _ctx.formTopic.description?.length,
                    maxLength: 700
                  }, null, 8, ["errors", "actualLength"])
                ])
              ])
            ]),
            _createVNode(_component_AddFileInput, {
              onOnSetImage: _ctx.setTopicImage,
              onOnResetImage: _ctx.resetTopicImage,
              imageSelected: _ctx.image
            }, null, 8, ["onOnSetImage", "onOnResetImage", "imageSelected"])
          ], 32)
        ]))
      : _createCommentVNode("", true)
  ]))
}